import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, } from '@wix/da-bi/pkg/events';
import MoreIcon from '@wix/da-ds/pkg/Icons/24x24/More';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import IconButtonWithContextMenu from '../../../Dropdown/Preset/IconButtonWithContextMenuV2';
import s from './MoreButton.scss';
var MoreButton = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, showReportModal = _a.showReportModal, showMobileDeviationSharePopup = _a.showMobileDeviationSharePopup, shareDeviationToPost = _a.shareDeviationToPost;
    var t = useTranslation().t;
    var _b = useDeviationAttributes(deviation, isOwner), isShareable = _b.isShareable, isReportable = _b.isReportable;
    return (React.createElement(IconButtonWithContextMenu, { className: s['root'], icon: MoreIcon, size: "medium", popperManagerProps: {
            openBiData: BiData({
                evid: 417,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                sectionname: 'deviation',
            }),
        }, items: [
            isShareable && {
                label: t('mobileDeviationHeader.moreActions.share'),
                onClick: showMobileDeviationSharePopup,
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId,
                }),
            },
            isShareable && {
                label: t('mobileDeviationHeader.moreActions.shareToPost'),
                onClick: shareDeviationToPost,
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId,
                }),
            },
            isReportable && {
                label: t('mobileDeviationHeader.moreActions.report'),
                onClick: showReportModal,
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId,
                }),
            },
        ] }));
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;
//# sourceMappingURL=MoreButton.js.map